<template>
  <transition name="sanitas-cookie-alert-fade">
    <div v-if="showAlert" class="sanitas-cookie-alert-container">
      <div class="info-container">
        <div class="info-container__text">
          <dotcom-icon
            class="info-icon"
            name="circle-info"
            art="light"
            color="--c-secondary-neutral-1"
            hover-color="--c-secondary-neutral-1"
          />
          <div class="sanitas-cookie-info" v-html="bannerText"></div>
        </div>
        <div class="cookie-alert-button-group">
          <dotcom-icon
            class="close-icon"
            name="xmark"
            art="light"
            color="--c-secondary-neutral-1"
            hover-color="--c-secondary-neutral-1"
            @click.native="acceptTerms"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'

export default {
  name: 'SanitasCookieAlert',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    cookieName: {
      type: String,
      default: 'sanitas-tracking-cookie-allow',
    },
    userChoiceEventName: {
      type: String,
      default: 'sanitas_cookie_alert_accepted',
    },
    bannerText: {
      type: String,
      default: 'bannerText',
    },
    optOut: Boolean,
  },

  setup(props) {
    const showAlert = ref(false)

    const acceptTerms = () => {
      setCookie(props.cookieName, 'true', 365)
      window.dispatchEvent(new CustomEvent(props.userChoiceEventName))
      showAlert.value = false
    }

    const setCookie = (cname, cvalue, exdays) => {
      let d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }

    onMounted(() => {
      document.cookie.indexOf(props.cookieName + '=') !== -1
        ? (showAlert.value = false)
        : (showAlert.value = true)
    })
    return {
      showAlert,
      acceptTerms,
    }
  },
}
</script>

<style lang="postcss">
.sanitas-cookie-alert-container {
  position: fixed;
  bottom: 0;
  left: 10px;
  right: 10px;
  z-index: 1200;
  display: flex;
  flex-direction: row;
  order: 0;
  align-items: center;
  justify-content: center;
  background-color: var(--c-secondary-neutral-3);
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.33;
  color: var(--c-primary-neutral-1);

  .info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: var(--spacing-4) var(--spacing-2);
  }

  .info-container__text {
    display: flex;
    align-items: center;
    gap: var(--spacing-2);
  }

  a {
    color: var(--c-primary-color-3);
    cursor: pointer;
  }

  .info-icon {
    font-size: 24px;
  }
  .close-icon {
    cursor: pointer;
    font-size: 16px;
  }

  .cookie-alert-button-group {
    display: flex;
    width: 40px;
    .cookie-alert-decline {
      width: 80px;
      height: 23px;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.25;
      text-align: right;
      color: var(--c-primary-color-3);
      text-decoration: underline;
      margin: 15px 0 0 20px;
    }

    .cookie-alert-decline:last-child {
      margin-bottom: 15px;
      margin-right: 20px;
    }

    .cookie-alert-accept {
      margin: 0 30px 0 45px;
    }
  }
}

.sanitas-cookie-alert-fade-enter-active,
.sanitas-cookie-alert-fade-leave-active {
  transition: opacity 0.6s;
}

.sanitas-cookie-alert-fade-enter,
.sanitas-cookie-alert-fade-leave-to {
  opacity: 0;
}

/*                       */
/* Tablet specific style */
/*                       */
@media (max-width: 768px) {
  .sanitas-cookie-alert-container {
    flex-direction: column;

    .sanitas-cookie-info {
      padding-right: 30px;
    }

    .cookie-alert-button-group {
      margin-bottom: 10px;
      justify-content: center;

      .cookie-alert-decline {
        margin: 15px 20px 0 20px;
      }
    }
  }
}
</style>
